import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"25%"}
}
const _hoisted_5 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "门店"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "排序"),
    /*#__PURE__*/_createElementVNode("th", null, "显示"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "创建时间"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "操作")
  ])
], -1)
const _hoisted_7 = { id: "member-list" }
const _hoisted_8 = { class: "mb-1 form-switch" }
const _hoisted_9 = ["checked", "onChange"]
const _hoisted_10 = { class: "flex-row flex-align-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddShopMealDialog = _resolveComponent("AddShopMealDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddMealDialog && $setup.openAddMealDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keywords) = $event))
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchMeal && $setup.searchMeal(...args)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, _toDisplayString((value.shopInfo) ? value.shopInfo.name : "未知"), 1),
                _createElementVNode("td", null, _toDisplayString(value.order), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      checked: value.show === 1,
                      onChange: ($event: any) => ($setup.updateMeal(value, 'show')),
                      type: "checkbox",
                      role: "switch"
                    }, null, 40, _hoisted_9)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString($setup.dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditMealDialog(value.id))
                    }, null, 8, _hoisted_11),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteMeal(value.id, value.name))
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadMealList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddShopMealDialog, {
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editMeal
    }, null, 8, ["show", "item", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}